import { Phonelink, PictureAsPdf } from '@mui/icons-material';
import { Box, Grid, Link, Typography } from '@mui/material';
import OnboardingGuide from '../../../assets/Enklakassan_Viva_Wallet_guide.pdf';

const VIVA_WALLET_SUPPORT_NUMBER = '073-5264639';

const VivaSupport = () => {
  return (
    <>
      <Grid item xs={12}>
        <Box display="flex" alignItems="center">
          <Phonelink sx={{ mr: 1 }} />
          <Typography variant="body1" component="span">
            Viva.com supportnummer:
          </Typography>
          <Link
            href={`tel:${VIVA_WALLET_SUPPORT_NUMBER}`}
            underline="hover"
            color="#000"
            sx={{ ml: 1 }}
          >
            {VIVA_WALLET_SUPPORT_NUMBER}
          </Link>
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Box display="flex" alignItems="center">
          <PictureAsPdf sx={{ mr: 1 }} />
          <Link
            href={OnboardingGuide}
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
            color="#000"
          >
            Onboarding guide
          </Link>
        </Box>
      </Grid>
    </>
  );
};

export default VivaSupport;
